import { Value } from "./PublicEntity";
export default class ActualDetail {
    constructor(actualdetail?: ActualDetail) {
        if (actualdetail) {
            Object.entries(actualdetail).forEach(([key, value]) => {
                this[key] = value
            })
        }
    }

    /**
     * 主单号：waybill_no
     */

    waybillNo?: Value;

    /**
     * 子单号：subBill_no
     */

    subBillNo?: Value;

    /**
     * 货物重量：goods_weight
     */

    goodsWeight?: number;

    /**
     * 结算重量?:
     */

    calcWeight?: number;

    /**
     * 运营重量：
     */

    operateWeight?: number;

    /**
     * 体积：
     */

    goodsVolume?: number;

    /**
     * 件数
     */

    piece?: number;

    /**
     * 票数
     */
    ticket?: number;

    /**
     * 产品类型
     */

    productType?: Value;

    /**
     * 时效要求(产品时效、次日达、隔日达)
     */

    lengthOfTime?: Value;

    /**
     * 是否必走货（是、否）
     */

    mustGoGoods?: Value;

    /**
     * 是否优势产品（是、否）
     */

    superiorityProduct?: Value;

    /**
     * 是否省内件
     */

    areaType?: Value;

    /**
     * 备注
     */

    remark?: Value;

    /**
     * 寄件网点
     */

    originSite?: Value;

    /**
     * 寄件网点编号
     */

    originSiteCode?: Value;

    /**
     * 寄件网点父级网点
     */

    originParentSite?: Value;

    /**
     * 寄件时间
     */

    sendDate?: Value;

    /**
     * 目的网点
     */

    destinationSite?: Value;

    /**
     * 目的分拨编号
     */

    destinationSiteCode?: Value;

    /**
     * 目的网点父级网点
     */

    destinationParentSite?: Value;

    /**
     * 签收时间
     */

    signDate?: Value;

    /**
     * 计划签收时间
     */
    theorySignDate?: Value;

    /**
     * 始发分拨
     */

    originCenter?: Value;

    
    countyAgingOriginCenterCode?: Value;


    countyAgingOriginCenter?: Value;

    /**
     * 始发分拨编码
     */

    originCenterCode?: Value;

    /**
     * 始发片区
     */

    originArea?: Value;

    /**
     * 始发大区
     */

    originBigArea?: Value;

    /**
     * 始发省区
     */

    originProvinceArea?: Value;

    /**
     * 始发省区编码
     */
    originProvinceAreaCode?: Value;

    /**
     * 始发区域
     */

    originRegion?: Value;

    /**
     * 始发省份
     */

    originProvince?: Value;

    /**
     * 始发城市
     */

    originCity?: Value;

    /**
     * 始发区县
     */

    originCounty?: Value;

    /**
     * 目的分拨
     */

    destinationCenter?: Value;
    countyAgingDestinationCenter?: Value;

    countyAgingDestinationCenterCode?: Value;

    /**
     * 目的分拨编码
     */

    destinationCenterCode?: Value;

    /**
     * 目的分拨片区
     */

    destinationArea?: Value;

    /**
     * 目的大区
     */

    destinationBigArea?: Value;

    /**
     * 目的省区
     */

    destinationProvinceArea?: Value;

    /**
     * 目的省区
     */

    destinationProvinceAreaCode?: Value;
    

    /**
     * 目的区域
     */

    destinationRegion?: Value;

    /**
     * 目的省份
     */

    destinationProvince?: Value;

    /**
     * 目的城市
     */

    destinationCity?: Value;

    /**
     * 目的县区
     */

    destinationCounty?: Value;

    /**
     * 分拨流向
     */

    centerDirection?: Value;

    /**
     * 第一段路由
     */

    firstRoute?: Value;

    /**
     * 第一段车线
     */

    firstTrackLine?: Value;

    /**
     * 线型（长线、短线）
     */

    firstTransportLineType?: Value;

    /**
     * 车型1
     */

    firstCarType?: Value;

    /**
     * 发车时间1
     */

    firstDepartureTime?: Value;

    /**
     * 到达时间1
     */

    firstArriveTime?: Value;

    /**
     * 第二段路由
     */

    secondRoute?: Value;

    /**
     * 第二段车线
     */

    secondTrackLine?: Value;

    /**
     * 线型（长线、短线）
     */

    secondTransportLineType?: Value;

    /**
     * 车型2
     */

    secondCarType?: Value;

    /**
     * 发车时间2
     */

    secondDepartureTime?: Value;

    /**
     * 到达时间2
     */

    secondArriveTime?: Value;

    /**
     * 第三段路由
     */

    thirdRoute?: Value;

    /**
     * 第三段车线
     */

    thirdTrackLine?: Value;

    /**
     * 线型（长线、短线）
     */

    thirdTransportLineType?: Value;

    /**
     * 车型3
     */

    thirdCarType?: Value;

    /**
     * 发车时间3
     */

    thirdDepartureTime?: Value;

    /**
     * 到达时间3
     */

    thirdArriveTime?: Value;

    /**
     * 第四段路由
     */

    fourthRoute?: Value;

    /**
     * 第四段车线
     */

    fourthTrackLine?: Value;

    /**
     * 线型（长线、短线）
     */

    fourthTransportLineType?: Value;

    /**
     * 车型4
     */

    fourthCarType?: Value;

    /**
     * 发车时间4
     */

    fourthDepartureTime?: Value;

    /**
     * 到达时间4
     */

    fourthArriveTime?: Value;

    /**
     * 第五段路由
     */

    fifthRoute?: Value;

    /**
     * 第五段车线
     */

    fifthTrackLine?: Value;

    /**
     * 线型（长线、短线）
     */

    fifthTransportLineType?: Value;

    /**
     * 车型5
     */

    fifthCarType?: Value;

    /**
     * 发车时间5
     */

    fifthDepartureTime?: Value;

    /**
     * 到达时间5
     */

    fifthArriveTime?: Value;


    /**
     * 第六段路由
     */

    sixthRoute?: Value;

    /**
     * 第六段车线
     */

    sixthTrackLine?: Value;

    /**
     * 线型（长线、短线）
     */

    sixthTransportLineType?: Value;

    /**
     * 车型6
     */

    sixthCarType?: Value;

    /**
     * 发车时间6
     */

    sixthDepartureTime?: Value;

    /**
     * 到达时间6
     */

    sixthArriveTime?: Value;

    /**
     * 第一分拨
     */

    firstCenter?: Value;

    /**
     * 第一分拨编号
     */

    firstCenterCode?: Value;

    /**
     * 第一片区
     */

    firstArea?: Value;

    /**
     * 第一大区
     */

    firstBigArea?: Value;

    /**
     * 第一省区
     */

    firstProvinceArea?: Value;

    /**
     * 第一区域
     */

    firstRegion?: Value;

    /**
     * 第一省份
     */

    firstProvince?: Value;

    /**
     * 第一城市
     */

    firstCity?: Value;

    /**
     * 第一县区
     */

    firstCounty?: Value;


    /**
     * 第二分拨
     */

    secondCenter?: Value;

    /**
     * 第二分拨编号
     */

    secondCenterCode?: Value;

    /**
     * 第二片区
     */

    secondArea?: Value;

    /**
     * 第二大区
     */

    secondBigArea?: Value;

    /**
     * 第二省区
     */

    secondProvinceArea?: Value;

    /**
     * 第二区域
     */

    secondRegion?: Value;

    /**
     * 第二省份
     */

    secondProvince?: Value;

    /**
     * 第二城市
     */

    secondCity?: Value;

    /**
     * 第二县区
     */

    secondCounty?: Value;


    /**
     * 第三分拨
     */

    thirdCenter?: Value;

    /**
     * 第三分拨编号
     */

    thirdCenterCode?: Value;

    /**
     * 第三片区
     */

    thirdArea?: Value;

    /**
     * 第三大区
     */

    thirdBigArea?: Value;

    /**
     * 第三省区
     */

    thirdProvinceArea?: Value;

    /**
     * 第三区域
     */

    thirdRegion?: Value;

    /**
     * 第三省份
     */

    thirdProvince?: Value;

    /**
     * 第三城市
     */

    thirdCity?: Value;

    /**
     * 第三县区
     */

    thirdCounty?: Value;


    /**
     * 第四分拨
     */

    fourthCenter?: Value;

    /**
     * 第四分拨编号
     */

    fourthCenterCode?: Value;

    /**
     * 第四片区
     */

    fourthArea?: Value;

    /**
     * 第四大区
     */

    fourthBigArea?: Value;

    /**
     * 第四省区
     */

    fourthProvinceArea?: Value;

    /**
     * 第四区域
     */

    fourthRegion?: Value;

    /**
     * 第四省份
     */

    fourthProvince?: Value;

    /**
     * 第四城市
     */

    fourthCity?: Value;

    /**
     * 第四县区
     */

    fourthCounty?: Value;

    /**
     * 第五分拨
     */

    fifthCenter?: Value;

    /**
     * 第五分拨编号
     */

    fifthCenterCode?: Value;

    /**
     * 第五片区
     */

    fifthArea?: Value;

    /**
     * 第五大区
     */

    fifthBigArea?: Value;

    /**
     * 第五省区
     */

    fifthProvinceArea?: Value;

    /**
     * 第五区域
     */

    fifthRegion?: Value;

    /**
     * 第五省份
     */

    fifthProvince?: Value;

    /**
     * 第五城市
     */

    fifthCity?: Value;

    /**
     * 第五县区
     */

    fifthCounty?: Value;

    /**
     * 第六分拨
     */

    sixthCenter?: Value;

    /**
     * 第六分拨编号
     */

    sixthCenterCode?: Value;

    /**
     * 第六片区
     */

    sixthArea?: Value;

    /**
     * 第六大区
     */

    sixthBigArea?: Value;

    /**
     * 第六省区
     */

    sixthProvinceArea?: Value;

    /**
     * 第六区域
     */

    sixthRegion?: Value;

    /**
     * 第六省份
     */

    sixthProvince?: Value;

    /**
     * 第六城市
     */

    sixthCity?: Value;

    /**
     * 第六县区
     */

    sixthCounty?: Value;

    /**
     * 交件时效
     */

    deliveryPeriod?: number;

    /**
     * 干线时效
     */

    trunkLinePeriod?: number;

    /**
     * 派件时效
     */

    dispatchPeriod?: number;

    /**
     * 全程时效
     */

    totalPeriod?: number;

    /**
     * 理论时效
     */

    theoryPeriod?: number;

    /**
     * 实际时效
     */

    actualPeriod?: number;

    /**
     * 延误天数
     */

    delayPeriod?: number;

    /**
     * 是否兑现
     */

    onTime?: Value;

    /**
     * 是否异常
     */

    abnormal?: Value;

}
